import { useTranslation } from "react-i18next";
import { Badge } from "@nexus/ui";

const VARIANT: Record<"success" | "failed" | "skipped", "status-delivered" | "status-error" | "slate"> = {
  success: "status-delivered",
  failed: "status-error",
  skipped: "slate",
};

const FALLBACK: Record<"success" | "failed" | "skipped", string> = {
  success: "Success",
  failed: "Failed",
  skipped: "Skipped",
};

export function EventOutcomeBadge({
  outcome,
}: {
  outcome: "success" | "failed" | "skipped";
}) {
  const { t } = useTranslation();
  return (
    <Badge variant={VARIANT[outcome]} dot>
      {t(`admin.events.outcome.${outcome}`, FALLBACK[outcome])}
    </Badge>
  );
}
